import TicketRow from "./TicketRow";
import TicketTextInput from "./TicketTextInput";

// LQC-2941 - the optional External ID (spec F3), sent as tradeDetails.transactionNumber.
interface ITicketExternalIdRow {
  testIdPrefix: string;
  value: string;
  onChange: (value: string) => void;
}

const TicketExternalIdRow = ({ testIdPrefix, value, onChange }: ITicketExternalIdRow) => (
  <TicketRow label="External ID" testId={`${testIdPrefix}ExternalIdRow`}>
    <TicketTextInput
      testId={`${testIdPrefix}ExternalIdInput`}
      value={value}
      placeholder="Optional reference"
      onChange={onChange}
    />
  </TicketRow>
);

export default TicketExternalIdRow;
